var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 15.7671C3.22386 15.7671 3 15.5433 3 15.2671V6.5C3 6.22386 3.22386 6 3.5 6C3.77614 6 4 6.22386 4 6.5L4 10.8988C4.40567 10.9452 4.80372 11.048 5.18247 11.2049C5.71588 11.4258 6.20054 11.7497 6.60879 12.1579C7.01705 12.5662 7.34089 13.0509 7.56184 13.5843C7.71877 13.9631 7.8216 14.3613 7.86802 14.7671H12.2671C12.5433 14.7671 12.7671 14.991 12.7671 15.2671C12.7671 15.5433 12.5433 15.7671 12.2671 15.7671H3.5ZM6.85955 14.7671C6.81878 14.493 6.74451 14.2242 6.63796 13.967C6.46727 13.5549 6.21708 13.1804 5.90169 12.865C5.58629 12.5497 5.21187 12.2995 4.79978 12.1288C4.54267 12.0223 4.27403 11.948 4 11.9072L4 14.7671H6.85955Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleIcon);
export default __webpack_public_path__ + "static/media/AngleIcon.afee4a529ed5bd79a5594511eb47e658.svg";
export { ForwardRef as ReactComponent };